// PwaInstallButton.tsx — Captures beforeinstallprompt and offers Install.
//
// CV-195: on Chromium browsers, beforeinstallprompt fires when the app meets
// install criteria. We stash the event, render a button, and call prompt()
// on user gesture. After install (or dismiss) the event is consumed.

import { useEffect, useState } from 'react';
import {
  shouldOfferInstall,
  type BeforeInstallPromptEvent,
} from '../utils/pwa';

export default function PwaInstallButton() {
  const [evt, setEvt] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    const onPrompt = (e: Event) => {
      e.preventDefault();
      setEvt(e as BeforeInstallPromptEvent);
    };
    const onInstalled = () => setEvt(null);
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      window.removeEventListener('beforeinstallprompt', onPrompt);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  if (!shouldOfferInstall(evt)) return null;

  return (
    <button
      type="button"
      className="pwa-install-button"
      onClick={async () => {
        if (!evt) return;
        await evt.prompt();
        await evt.userChoice;
        setEvt(null);
      }}
    >
      Install app
    </button>
  );
}
